export const webappLabels = {
  /* The one message existing Teams users get about the web app. */
  webapp_intro_title: {
    en: 'New: your own Wundo page',
    nl: 'Nieuw: je eigen Wundo-pagina',
    fr: 'Nouveau : votre propre page Wundo',
  },
  webapp_intro_body_first: {
    en: 'You keep using Wundo in Teams as before, now with a much-requested addition: a page for your important conversations.',
    nl: 'Je blijft Wundo gewoon in Teams gebruiken, maar nu met een veelgevraagde toevoeging: een pagina voor je belangrijke gesprekken.',
    fr: 'Vous continuez à utiliser Wundo dans Teams comme avant, avec un ajout très demandé : une page pour vos conversations importantes.',
  },
  webapp_intro_body_second: {
    en: 'Preparations, reports and open agreements are there together, per conversation and per person.',
    nl: 'Voorbereidingen, verslagen en openstaande afspraken staan er samen, per gesprek en per persoon.',
    fr: 'Préparations, comptes rendus et accords en cours y sont réunis, par conversation et par personne.',
  },
  webapp_intro_action: {
    en: 'Activate Wundo',
    nl: 'Activeer Wundo',
    fr: 'Activer Wundo',
  },
  webapp_intro_overview_title: {
    en: 'All your conversations in one place',
    nl: 'Al je gesprekken op één plek',
    fr: 'Toutes vos conversations au même endroit',
  },
  webapp_intro_overview_text: {
    en: 'No more scrolling back through your chat to find something.',
    nl: 'Nooit meer terugscrollen in je chat om iets terug te vinden.',
    fr: 'Plus besoin de remonter dans votre chat pour retrouver quelque chose.',
  },
  webapp_intro_prep_title: {
    en: 'Never start from scratch again',
    nl: 'Begin nooit meer van nul',
    fr: 'Ne repartez plus jamais de zéro',
  },
  webapp_intro_prep_text: {
    en: 'Pick the type of conversation and Wundo has your preparation ready. You can add to it right away.',
    nl: 'Kies het type gesprek en Wundo zet je voorbereiding klaar. Aanvullen kan meteen.',
    fr: 'Choisissez le type de conversation et Wundo rédige votre préparation. Vous pouvez la compléter tout de suite.',
  },
  webapp_intro_thread_title: {
    en: 'One thread through all your conversations',
    nl: 'Eén rode draad door al je gesprekken',
    fr: 'Un fil rouge à travers toutes vos conversations',
  },
  webapp_intro_thread_text: {
    en: 'What you discuss and agree on comes back by itself in your next preparation.',
    nl: 'Wat je bespreekt en afspreekt, komt vanzelf terug in je volgende voorbereiding.',
    fr: 'Ce que vous abordez et ce dont vous convenez revient de lui-même dans votre prochaine préparation.',
  },
  /*
   * The same card as a welcome for someone who has just arrived: another head
   * and foot, the same three pictures. `{name}` carries its own comma, because
   * a Teams user reached before they opened the app has only an address, and
   * "Welkom bij Wundo, " reads as a bug.
   */
  webapp_welcome_title: {
    en: 'Welcome to Wundo{name}',
    nl: 'Welkom bij Wundo{name}',
    fr: 'Bienvenue chez Wundo{name}',
  },
  webapp_welcome_body_first: {
    en: 'Wundo prepares your important conversations and makes sure nothing gets lost between one conversation and the next.',
    nl: 'Wundo bereidt je belangrijke gesprekken voor en zorgt dat er niets tussen twee gesprekken verloren gaat.',
    fr: 'Wundo prépare vos conversations importantes et veille à ce que rien ne se perde entre deux conversations.',
  },
  webapp_welcome_body_second: {
    en: 'Tell Wundo which conversations you want support with, and your preparation is ready before the conversation starts.',
    nl: 'Geef aan bij welke gesprekken je ondersteuning wil, dan staat je voorbereiding klaar vóór het gesprek begint.',
    fr: 'Indiquez pour quelles conversations vous souhaitez un accompagnement, et votre préparation est prête avant que la conversation ne commence.',
  },
  /* The AI-use disclosure, required in every language; it stays verbatim. */
  webapp_welcome_footnote: {
    en: 'Wundo uses AI to generate its responses.',
    nl: 'Wundo maakt gebruik van AI om antwoorden te genereren.',
    fr: "Wundo utilise l'IA pour générer ses réponses.",
  },
  start_with_wundo: {
    en: 'Start with Wundo',
    nl: 'Start met Wundo',
    fr: 'Commencer avec Wundo',
  },
} as const satisfies Record<string, Record<string, string>>;
